export default __webpack_public_path__ + "static/media/cp_geo_jm.818a3c55.svg";